// Copyright (c) StrangeBee 2024

import { classList } from '@Helpers/className';
import Table, { TableProps } from 'antd/lib/table';
import React, { forwardRef, ReactNode } from 'react';

import './Content.scss';

const defaultScroll = { x: 'auto' };

interface ContentProps extends TableProps<any> {
    name?: string;
    className?: string;
    emptyPlaceholder?: ReactNode;
}

const Content = forwardRef<HTMLDivElement, ContentProps>(
    ({ name, className, dataSource, columns, rowKey, scroll, emptyPlaceholder, ...props }, ref) => {
        const TableComponent = (
            <Table
                className={classList('custom-table__table', className)}
                dataSource={dataSource}
                columns={columns}
                rowKey={rowKey}
                pagination={false}
                rowClassName="custom-table__row"
                scroll={{ ...defaultScroll, ...scroll }}
                {...props}
            />
        );

        return (
            <div className={classList('th-list-content', 'custom-table')} ref={ref}>
                {name ? <p className="custom-table__title">{name}</p> : null}
                {emptyPlaceholder ? (!!dataSource?.length ? TableComponent : emptyPlaceholder) : TableComponent}
            </div>
        );
    },
);

Content.displayName = 'Content';

export default Content;
